/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlFamilyProAuthorizationStateFieldsFragment = {
  __typename: "FamilyProAuthorizationState";
  isAuthorized: boolean;
};

export const FamilyProAuthorizationStateFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "familyProAuthorizationStateFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FamilyProAuthorizationState" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isAuthorized" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlFamilyProAuthorizationStateFieldsFragment,
  unknown
>;
